import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Link as ReactRouterLink } from 'react-router-dom';
import { string } from 'prop-types';
import { generateICSFile } from '../../../../../core/utils/icalendar';
import { devices } from '../card/options';
import TimezoneDropdown from '../../../../../core/components/timezone-dropdown';
import { config } from '../../../../../config';

import {
  Disclaimer,
  DisclaimerContainer,
  Dropdown,
  Link,
  Moderated,
  ModeratedRaw,
  Text,
  TimezoneContainer,
  Title,
  Warning,
} from './styles';

const ModeratedStudy = (props) => {
  const {
    date, time, timezone: defaultTimezone, device, startAt, endAt, intermediateMeetingPagePath,
  } = props;

  const [icsFile, setIcsFile] = useState(null);
  const [toggleTime, setToggleTime] = useState(false);
  const [timezone, setTimezone] = useState();
  const [bookingTime, setBookingTime] = useState();

  const intermediateMeetingPageUrl = `${config.REACT_APP_TESTER_PLATFORM_URI}${intermediateMeetingPagePath}`;

  const handleChangeTimezone = (value) => {
    setTimezone(value);
    const formattedTime = moment(moment.tz(time, value)).format('LT');
    setBookingTime(formattedTime);
  };

  const handleChangeToggle = () => {
    setToggleTime((prev) => !prev);
  };

  useEffect(() => {
    if (!timezone) {
      setTimezone(defaultTimezone);
    }

    if (!bookingTime) {
      setBookingTime(moment.tz(time, timezone || defaultTimezone).format('LT'));
    }
  }, [bookingTime, defaultTimezone, time, timezone]);

  useEffect(() => {
    (async () => {
      const summary = 'Research Session';
      /* eslint-disable max-len */
      const description = `Please join the session from a ${device} 5 minutes before the scheduled time to ensure everything is working correctly.`;

      // TODO: fix call link when zoom integration is completed
      const location = intermediateMeetingPageUrl;

      const file = await generateICSFile({
        summary,
        description,
        location,
        startAt,
        endAt,
      });

      setIcsFile(file);
    })();
  }, [device, endAt, startAt, intermediateMeetingPageUrl]);

  const otherDevices = Object.keys(devices)
    .filter((d) => d !== device)
    .map((k) => devices[k])
    .join(' or a ');

  return (
    <Moderated>
      <Title>{date}</Title>

      <TimezoneContainer>
        <Title>
          {`${bookingTime},`}
        </Title>

        <TimezoneDropdown
          onChange={handleChangeTimezone}
          timeZone={timezone}
          toggleTime={toggleTime}
          onChangeToggle={handleChangeToggle}
        />
      </TimezoneContainer>

      <ModeratedRaw>
        <Link to={intermediateMeetingPagePath}>Join meeting</Link>
        <Dropdown item text="Actions" icon="caret down" direction="right">
          <Dropdown.Menu>
            <Dropdown.Item
              href={`data:text/calendar;charset=utf8,${escape(icsFile)}`}
              as="a"
            >
              Add to calendar
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </ModeratedRaw>
      <Warning>
        Join on a
        {' '}
        {device}
        {' '}
        (not a
        {' '}
        {otherDevices}
        )
      </Warning>
      <Text>
        At the time of your session, click &quot;Join Meeting&quot; or enter
        this link in your browser:
        {' '}
        <ReactRouterLink to={intermediateMeetingPagePath}>{intermediateMeetingPageUrl}</ReactRouterLink>
      </Text>
      <DisclaimerContainer>
        <Disclaimer>
          If you do not show for this moderated session, you will not be able to participate in another moderated session for 12 months.
        </Disclaimer>
      </DisclaimerContainer>
    </Moderated>
  );
};

ModeratedStudy.propTypes = {
  date: string.isRequired,
  time: string.isRequired,
  timezone: string.isRequired,
  device: string.isRequired,
  startAt: string.isRequired,
  endAt: string.isRequired,
  intermediateMeetingPagePath: string.isRequired,
};

export default ModeratedStudy;
